import { TodoListId, TodoListIdType, isTodoMyDayList, isTodoFolderList } from 'owa-todo-list-types';
import { ControlIcons } from 'owa-control-icons';
import { assertNever } from 'owa-assert';
import { getTodoFolderById } from 'owa-todo-folders';
import { TodoFolder } from 'owa-todo-types';
import { getMyDayListData } from './getMyDayListData';

export interface ListPickerElement {
    Name: string;
    Id: TodoListId;
    IconBefore: string;
    IconAfter: string;
}

export function getListPickerElement(listId: TodoListId): ListPickerElement {
    if (isTodoFolderList(listId)) {
        return getListPickerElementForFolder(listId.Id);
    } else if (isTodoMyDayList(listId)) {
        const { text, icon } = getMyDayListData();
        return {
            Name: text,
            Id: { type: TodoListIdType.MyDay },
            IconBefore: icon,
            IconAfter: null,
        };
    }
    assertNever(listId);
}

function getListPickerElementForFolder(folderId: string): ListPickerElement {
    const folder = getTodoFolderById(folderId);
    return {
        Name: folder?.Name ?? '',
        Id: { type: TodoListIdType.Folder, Id: folderId },
        IconBefore: getIconForFolder(folder),
        IconAfter: folder?.IsSharedFolder ? ControlIcons.People : null,
    };
}

function getIconForFolder(folder: TodoFolder): string {
    if (folder?.IsDefaultFolder) {
        return ControlIcons.Home;
    } else if (folder?.FolderType === 'Commitments') {
        return ControlIcons.OutlookLogoInverse;
    } else if (folder?.FolderType === 'FlaggedEmails') {
        return ControlIcons.Flag;
    }
    return ControlIcons.BulletedList;
}
